export type RegisterSource = 'seasonalBox' | 'seasonalBoxReactivation' | 'publicCustomize' | 'introProduct';

export interface SubscriptionRequest {
  currency: string;
  plan: string;
  coupon: string;
  recurly_token_id: string;
}

export interface UserRequest {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}

export enum PaymentType {
  PAYPAL = 'paypal',
  CREDIT_CARD = 'credit_card',
  APPLE_PAY = 'apple_pay',
}

export interface BillingRequest {
  payment_type: PaymentType | string;
  preferred_locale: string;
  has_gdpr: boolean;
}

export interface ShippingRequest {
  ship_country: string;
  ship_state: string;
  ship_zipcode: string;
}

export interface AdditionalShippingRequest {
  ship_first_name: string;
  ship_last_name: string;
  ship_address_1: string;
  ship_address_2: string;
  ship_city: string;
  ship_phone?: string;
}

export interface RegisterRequest {
  customize_requests: [];
  billing_request: BillingRequest;
  shipping_request: ShippingRequest;
  additional_shipping_request: AdditionalShippingRequest;
  subscription_request: SubscriptionRequest;
  user_request: UserRequest;
  campaign_id: number;
  cart_id?: number | null,
  invite_code: string;
  uuid?: string | null;
  source: RegisterSource;
}

export interface IntroProductRegisterRequest extends RegisterRequest {
  subscription_items: string[];
}

export interface CountryState {
  countryIsoCode: string;
  countryName: string;
}
